{
  "„{name}“ hat nur die Admin-Rolle und wird vollständig gelöscht. Das kann nicht rückgängig gemacht werden.": "„{name}“ hat nur die Admin-Rolle und wird vollständig gelöscht. Das kann nicht rückgängig gemacht werden.",
  "„{name}“ hat nur die Client-Rolle und wird vollständig gelöscht. Dabei werden auch {accommodations} samt aller zugehörigen Daten unwiderruflich gelöscht und können nicht wiederhergestellt werden.": "„{name}“ hat nur die Client-Rolle und wird vollständig gelöscht. Dabei werden auch {accommodations} samt aller zugehörigen Daten unwiderruflich gelöscht und können nicht wiederhergestellt werden.",
  "„{name}“ hat weitere Rollen. Es wird nur die Admin-Rolle entfernt; das Konto bleibt bestehen.": "„{name}“ hat weitere Rollen. Es wird nur die Admin-Rolle entfernt; das Konto bleibt bestehen.",
  "„{name}“ hat weitere Rollen. Es wird nur die Client-Rolle entfernt; das Konto und die {accommodations} bleiben bestehen.": "„{name}“ hat weitere Rollen. Es wird nur die Client-Rolle entfernt; das Konto und die {accommodations} bleiben bestehen.",
  "„{name}“ ist jetzt für Gäste sichtbar.": "„{name}“ ist jetzt für Gäste sichtbar.",
  "„{name}“ wurde gespeichert.": "„{name}“ wurde gespeichert.",
  "„{name}“ wurde zurückgezogen.": "„{name}“ wurde zurückgezogen.",
  "„{title}“ wurde gespeichert und gegen den Import gesperrt.": "„{title}“ wurde gespeichert und gegen den Import gesperrt.",
  "(abgesagt)": "(abgesagt)",
  "(Gastgeber-Zugang)": "(Gastgeber-Zugang)",
  "(gekürzt — die nächstgelegenen zuerst)": "(gekürzt — die nächstgelegenen zuerst)",
  "(jeder {step}. gezeichnet)": "(jeder {step}. gezeichnet)",
  "(Plattform-Zugang)": "(Plattform-Zugang)",
  "{content} regionale Inhalte aus {sources} Datenquellen stehen allen Gästemappen zur Verfügung.": "{content} regionale Inhalte aus {sources} Datenquellen stehen allen Gästemappen zur Verfügung.",
  "{count} Anfragen": {
    "one": "{n} Anfrage",
    "other": "{n} Anfragen"
  },
  "{count} Anfragen ohne hinterlegten Preis": {
    "one": "{n} Anfrage ohne hinterlegten Preis — nicht in der Summe enthalten",
    "other": "{n} Anfragen ohne hinterlegten Preis — nicht in der Summe enthalten"
  },
  "{count} Einträge innerhalb von {radius} entlang der Strecke": {
    "one": "{count} Eintrag innerhalb von {radius} entlang der Strecke",
    "other": "{count} Einträge innerhalb von {radius} entlang der Strecke"
  },
  "{count} Garten": "{count} Garten",
  "{count} innen": "{count} innen",
  "{count} Kategorien": {
    "one": "{count} Kategorie",
    "other": "{count} Kategorien"
  },
  "{count} markiert": "{count} markiert",
  "{count} Quellen fehlgeschlagen": {
    "one": "{n} Quelle fehlgeschlagen",
    "other": "{n} Quellen fehlgeschlagen"
  },
  "{count} Streckenpunkte": "{count} Streckenpunkte",
  "{count} Terrasse": "{count} Terrasse",
  "{count} Unterkünfte": {
    "one": "{count} Unterkunft",
    "other": "{count} Unterkünfte"
  },
  "{count} Unterkünfte live.": {
    "one": "{n} Unterkunft live.",
    "other": "{n} Unterkünfte live."
  },
  "{distance} von der Strecke": "{distance} von der Strecke",
  "{months} Monate": "{months} Monate",
  "{n} aktiv": "{n} aktiv",
  "{n} aktualisiert": "{n} aktualisiert",
  "{n} archiviert": "{n} archiviert",
  "{n} außerhalb des Umkreises": "{n} außerhalb des Umkreises",
  "{n} Bilder kopiert": "{n} Bilder kopiert",
  "{n} Bilder offen": "{n} Bilder offen",
  "{n} Bilder ohne passende Lizenz": "{n} Bilder ohne passende Lizenz",
  "{n} Dubletten erkannt": "{n} Dubletten erkannt",
  "{n} Dubletten freigegeben": "{n} Dubletten freigegeben",
  "{n} Entwurf": "{n} Entwurf",
  "{n} fehlerhaft": "{n} fehlerhaft",
  "{n} gesperrt": "{n} gesperrt",
  "{n} neu": "{n} neu",
  "{n} unverändert": "{n} unverändert",
  "{n} veröffentlicht": "{n} veröffentlicht",
  "{time} Uhr": "{time} Uhr",
  "+ {count} weitere": "+ {count} weitere",
  "Ab heute in die Zukunft.": "Ab heute in die Zukunft.",
  "Abbrechen": "Abbrechen",
  "Abgesagt": "Abgesagt",
  "Abmelden": "Abmelden",
  "Abonnements": "Abonnements",
  "Abstieg": "Abstieg",
  "Admin": "Admin",
  "Admin bearbeiten": "Admin bearbeiten",
  "Admin-Benutzer „{name}“ wurde aktualisiert.": "Admin-Benutzer „{name}“ wurde aktualisiert.",
  "Admin-Benutzer „{name}“ wurde angelegt.": "Admin-Benutzer „{name}“ wurde angelegt.",
  "Admin-Rolle entfernen?": "Admin-Rolle entfernen?",
  "Admin-Rolle wurde entfernt.": "Admin-Rolle wurde entfernt.",
  "Administrator": "Administrator",
  "Administratoren der Plattform": "Administratoren der Plattform",
  "Adresse": "Adresse",
  "Adresse (optional)": "Adresse (optional)",
  "Airbnb": "Airbnb",
  "Aktion nicht möglich (ggf. eigenes Konto).": "Aktion nicht möglich (ggf. eigenes Konto).",
  "Aktionen": "Aktionen",
  "aktiv": "aktiv",
  "Aktiv": "Aktiv",
  "Aktivität": "Aktivität",
  "Aktualisieren": "Aktualisieren",
  "Aktualisieren fehlgeschlagen. Bitte versuche es später erneut.": "Aktualisieren fehlgeschlagen. Bitte versuche es später erneut.",
  "Aktualisiert am": "Aktualisiert am",
  "Alle": "Alle",
  "Alle Aktivitäten": "Alle Aktivitäten",
  "Alle Datensätze dieser Quelle werden dieser Region zugeordnet.": "Alle Datensätze dieser Quelle werden dieser Region zugeordnet.",
  "Alle Einträge aus „{log}“ wurden gelöscht.": "Alle Einträge aus „{log}“ wurden gelöscht.",
  "Alle Einträge löschen?": "Alle Einträge löschen?",
  "Alle Kategorien": "Alle Kategorien",
  "Alle kommenden": "Alle kommenden",
  "Alle Längen": "Alle Längen",
  "Alle löschen": "Alle löschen",
  "Alle Quellen": "Alle Quellen",
  "Alle Tenants auf einen Blick.": "Alle Tenants auf einen Blick.",
  "Alle Unterkünfte der Plattform": "Alle Unterkünfte der Plattform",
  "Allgemein": "Allgemein",
  "Als Dublette erkannt": "Als Dublette erkannt",
  "Als Empfehlung hervorheben": "Als Empfehlung hervorheben",
  "als Entwurf": "als Entwurf",
  "Analytics": "Analytics",
  "Anbieter liefern unbearbeitete Originale (im Schnitt 1,5 MB, teils über 70 MB). Beim Kopieren werden sie auf diese Kantenlänge verkleinert und als WebP gespeichert.": "Anbieter liefern unbearbeitete Originale (im Schnitt 1,5 MB, teils über 70 MB). Beim Kopieren werden sie auf diese Kantenlänge verkleinert und als WebP gespeichert.",
  "Anbieter-ID": "Anbieter-ID",
  "Anbieter-Seite": "Anbieter-Seite",
  "Anfahrt": "Anfahrt",
  "Anfragen": "Anfragen",
  "Angemeldet bleiben": "Angemeldet bleiben",
  "Anlegen": "Anlegen",
  "Anlegen fehlgeschlagen. Bitte versuche es später erneut.": "Anlegen fehlgeschlagen. Bitte versuche es später erneut.",
  "Anmelden": "Anmelden",
  "Anmeldung fehlgeschlagen. Bitte versuche es später erneut.": "Anmeldung fehlgeschlagen. Bitte versuche es später erneut.",
  "Ansehen": "Ansehen",
  "Apartment": "Apartment",
  "API-Anfragen": "API-Anfragen",
  "Architektur": "Architektur",
  "Archiviert": "Archiviert",
  "Archiviert — aus dem Feed entfernt": "Archiviert — aus dem Feed entfernt",
  "Asphalt": "Asphalt",
  "Aufenthalte": "Aufenthalte",
  "Aufstieg": "Aufstieg",
  "aus der Quelle": "aus der Quelle",
  "Ausblenden": "Ausblenden",
  "Ausflugsziele, Aussichtspunkte und Museen der Region": "Ausflugsziele, Aussichtspunkte und Museen der Region",
  "Aussichtspunkt": "Aussichtspunkt",
  "Auswahl aufheben": "Auswahl aufheben",
  "automatisch": "automatisch",
  "B&B": "B&B",
  "Bäckerei": "Bäckerei",
  "Bad & Badestelle": "Bad & Badestelle",
  "Bar": "Bar",
  "Barrierefreies WC": "Barrierefreies WC",
  "Barrierefreiheit": "Barrierefreiheit",
  "Basis": "Basis",
  "Bearbeiten": "Bearbeiten",
  "Behalte den Überblick über alle Gastgeber, Tenants und Regionen — an einem Ort.": "Behalte den Überblick über alle Gastgeber, Tenants und Regionen — an einem Ort.",
  "beim Anbieter verlinkt": "beim Anbieter verlinkt",
  "Beim nächsten Import werden alle manuellen Änderungen an dieser Veranstaltung durch die Daten der Quelle ersetzt.": "Beim nächsten Import werden alle manuellen Änderungen an dieser Veranstaltung durch die Daten der Quelle ersetzt.",
  "Beim Speichern wird die Veranstaltung gegen den täglichen Import gesperrt, damit deine Änderungen erhalten bleiben.": "Beim Speichern wird die Veranstaltung gegen den täglichen Import gesperrt, damit deine Änderungen erhalten bleiben.",
  "BELTURO Cloud — Interner Operator-Zugang.": "BELTURO Cloud — Interner Operator-Zugang.",
  "BELTURO Plattform": "BELTURO Plattform",
  "Benachrichtigungen": "Benachrichtigungen",
  "Benutzer": "Benutzer",
  "Benutzer konnten nicht geladen werden": "Benutzer konnten nicht geladen werden",
  "Benutzer löschen?": "Benutzer löschen?",
  "Benutzer wurde gelöscht.": "Benutzer wurde gelöscht.",
  "Benutzer wurde nicht gefunden.": "Benutzer wurde nicht gefunden.",
  "Benutzerdetails": "Benutzerdetails",
  "Benutzern": "Benutzern",
  "Berghütte": "Berghütte",
  "Beschreibung": "Beschreibung",
  "Bewertungen": "Bewertungen",
  "Biergarten": "Biergarten",
  "Bilder": "Bilder",
  "Bilder in unseren Speicher kopieren statt zu verlinken": "Bilder in unseren Speicher kopieren statt zu verlinken",
  "Bio": "Bio",
  "bis": "bis",
  "bis {km} km": "bis {km} km",
  "Bitte gib dein Passwort ein.": "Bitte gib dein Passwort ein.",
  "Bitte gib eine E-Mail-Adresse ein.": "Bitte gib eine E-Mail-Adresse ein.",
  "Bitte gib eine gültige E-Mail-Adresse ein.": "Bitte gib eine gültige E-Mail-Adresse ein.",
  "Bitte gib eine gültige URL ein (inkl. https://).": "Bitte gib eine gültige URL ein (inkl. https://).",
  "Bitte gib einen Firmennamen ein.": "Bitte gib einen Firmennamen ein.",
  "Bitte gib einen Namen ein.": "Bitte gib einen Namen ein.",
  "Bitte gib einen Slug (Subdomain) ein.": "Bitte gib einen Slug (Subdomain) ein.",
  "Bitte gib einen Titel ein.": "Bitte gib einen Titel ein.",
  "Bitte höchstens {count} Zeichen eingeben.": "Bitte höchstens {count} Zeichen eingeben.",
  "Bitte mindestens {count} Zeichen eingeben.": "Bitte mindestens {count} Zeichen eingeben.",
  "Bitte überprüfe das Format dieser Eingabe.": "Bitte überprüfe das Format dieser Eingabe.",
  "Bitte überprüfe deine Eingaben.": "Bitte überprüfe deine Eingaben.",
  "Bitte versuche es später erneut.": "Bitte versuche es später erneut.",
  "Bitte wähle einen Eigentümer (Client) aus.": "Bitte wähle einen Eigentümer (Client) aus.",
  "Bitte wählen …": "Bitte wählen …",
  "Blindenführhund erlaubt": "Blindenführhund erlaubt",
  "Bootsverleih": "Bootsverleih",
  "Brauerei": "Brauerei",
  "Bücherei": "Bücherei",
  "Burg & Schloss": "Burg & Schloss",
  "Café": "Café",
  "Camping": "Camping",
  "Client": "Client",
  "Client bearbeiten": "Client bearbeiten",
  "Client-Benutzer „{name}“ wurde aktualisiert.": "Client-Benutzer „{name}“ wurde aktualisiert.",
  "Client-Benutzer „{name}“ wurde angelegt.": "Client-Benutzer „{name}“ wurde angelegt.",
  "Client-Rolle entfernen?": "Client-Rolle entfernen?",
  "Client-Rolle wurde entfernt.": "Client-Rolle wurde entfernt.",
  "Clients": "Clients",
  "Clients der Plattform": "Clients der Plattform",
  "Club": "Club",
  "Das Passwort muss mindestens 6 Zeichen lang sein.": "Das Passwort muss mindestens 6 Zeichen lang sein.",
  "Daten": "Daten",
  "Datenquelle bearbeiten": "Datenquelle bearbeiten",
  "Datenquellen": "Datenquellen",
  "Datenquellen konnten nicht geladen werden": "Datenquellen konnten nicht geladen werden",
  "Datentyp beim Anbieter": "Datentyp beim Anbieter",
  "Dauer": "Dauer",
  "Dauerhaft geschlossen": "Dauerhaft geschlossen",
  "Debug": "Debug",
  "Deine Sitzung wurde sicher beendet. Bis bald!": "Deine Sitzung wurde sicher beendet. Bis bald!",
  "Denkmal": "Denkmal",
  "Der Datenpool, den der Lizenzschlüssel freischaltet.": "Der Datenpool, den der Lizenzschlüssel freischaltet.",
  "Der Eintrag wurde nicht gefunden.": "Der Eintrag wurde nicht gefunden.",
  "Detail": "Detail",
  "Details": "Details",
  "Di": "Di",
  "Die Änderung wurde abgelehnt.": "Die Änderung wurde abgelehnt.",
  "Die Karte konnte nicht geladen werden. Der Streckenverlauf wird als Skizze angezeigt.": "Die Karte konnte nicht geladen werden. Der Streckenverlauf wird als Skizze angezeigt.",
  "Die Quelle konnte nicht abgefragt werden. Details stehen an der Quelle.": "Die Quelle konnte nicht abgefragt werden. Details stehen an der Quelle.",
  "Die Quelle wurde nicht gefunden.": "Die Quelle wurde nicht gefunden.",
  "Die Tour wurde nicht gefunden.": "Die Tour wurde nicht gefunden.",
  "Die Veranstaltung folgt wieder ihrer Quelle.": "Die Veranstaltung folgt wieder ihrer Quelle.",
  "Die Veranstaltung wird Gästen wieder angezeigt und beim nächsten Import nicht erneut automatisch zugeordnet.": "Die Veranstaltung wird Gästen wieder angezeigt und beim nächsten Import nicht erneut automatisch zugeordnet.",
  "Die Veranstaltung wird wieder angezeigt.": "Die Veranstaltung wird wieder angezeigt.",
  "Die Veranstaltung wurde nicht gefunden.": "Die Veranstaltung wurde nicht gefunden.",
  "Diese E-Mail-Adresse wird bereits verwendet.": "Diese E-Mail-Adresse wird bereits verwendet.",
  "Diese Quelle liefert für diese Veranstaltung keine Bilder.": "Diese Quelle liefert für diese Veranstaltung keine Bilder.",
  "Diese Tour ist gegen den Import gesperrt.": "Diese Tour ist gegen den Import gesperrt.",
  "Diese Veranstaltung wurde bereits über eine andere Quelle importiert und wird Gästen deshalb nicht angezeigt. Wenn es sich doch um eine eigenständige Veranstaltung handelt, lässt sich die Verknüpfung aufheben — sie wird dann sichtbar und künftig nicht mehr automatisch zugeordnet.": "Diese Veranstaltung wurde bereits über eine andere Quelle importiert und wird Gästen deshalb nicht angezeigt. Wenn es sich doch um eine eigenständige Veranstaltung handelt, lässt sich die Verknüpfung aufheben — sie wird dann sichtbar und künftig nicht mehr automatisch zugeordnet.",
  "Diese Veranstaltung wurde manuell bearbeitet und wird vom täglichen Import nicht mehr überschrieben.": "Diese Veranstaltung wurde manuell bearbeitet und wird vom täglichen Import nicht mehr überschrieben.",
  "dieser Benutzer": "dieser Benutzer",
  "Dieser Eintrag ist gegen den Import gesperrt.": "Dieser Eintrag ist gegen den Import gesperrt.",
  "Dieser Slug ist bereits vergeben.": "Dieser Slug ist bereits vergeben.",
  "Dieses Feld ist erforderlich.": "Dieses Feld ist erforderlich.",
  "Distanz": "Distanz",
  "Do": "Do",
  "Draußen": "Draußen",
  "Du bist abgemeldet": "Du bist abgemeldet",
  "Du wirst im Client-Admin von \"{name}\" automatisch als dessen Eigentümer angemeldet.": "Du wirst im Client-Admin von \"{name}\" automatisch als dessen Eigentümer angemeldet.",
  "Dublette": "Dublette",
  "Dublette — diese Tour existiert bereits und wird Gästen nicht angezeigt": "Dublette — diese Tour existiert bereits und wird Gästen nicht angezeigt",
  "Dublette — diese Veranstaltung kam bereits über eine andere Quelle und wird Gästen nicht angezeigt": "Dublette — diese Veranstaltung kam bereits über eine andere Quelle und wird Gästen nicht angezeigt",
  "Dublette — dieser Eintrag existiert bereits und wird Gästen nicht angezeigt": "Dublette — dieser Eintrag existiert bereits und wird Gästen nicht angezeigt",
  "Dublette — dieser Eintrag kam bereits über eine andere Quelle und wird Gästen nicht angezeigt": "Dublette — dieser Eintrag kam bereits über eine andere Quelle und wird Gästen nicht angezeigt",
  "Dubletten": "Dubletten",
  "Dubletten anderer Quellen erkennen": "Dubletten anderer Quellen erkennen",
  "E-Mail": "E-Mail",
  "E-Mail (optional)": "E-Mail (optional)",
  "Eigentümer": "Eigentümer",
  "Eigentümer (Client)": "Eigentümer (Client)",
  "Eine Änderung sperrt den Eintrag gegen den nächsten Import.": "Eine Änderung sperrt den Eintrag gegen den nächsten Import.",
  "Eine Änderung sperrt die Tour gegen den nächsten Import.": "Eine Änderung sperrt die Tour gegen den nächsten Import.",
  "Eine Plattform.": "Eine Plattform.",
  "Einen Moment bitte.": "Einen Moment bitte.",
  "Einstellungen": "Einstellungen",
  "Eintrag": "Eintrag",
  "Eintrag konnte nicht geladen werden.": "Eintrag konnte nicht geladen werden.",
  "Einträge": "Einträge",
  "Einträge pro Abruf": "Einträge pro Abruf",
  "Einträgen": "Einträgen",
  "Eisdiele": "Eisdiele",
  "Endgültig löschen": "Endgültig löschen",
  "Endpunkt (URL)": "Endpunkt (URL)",
  "Entwurf": "Entwurf",
  "Entwurf — nicht sichtbar": "Entwurf — nicht sichtbar",
  "erfolgreich": "erfolgreich",
  "Ernährung": "Ernährung",
  "Erscheint auf der Karte in der Gäste-App.": "Erscheint auf der Karte in der Gäste-App.",
  "Erstellt am": "Erstellt am",
  "Es liegen keine API-Anfragen vor.": "Es liegen keine API-Anfragen vor.",
  "Es liegen keine Systemprotokoll-Einträge vor.": "Es liegen keine Systemprotokoll-Einträge vor.",
  "Es werden die ersten {limit} Einträge angezeigt. Grenze die Auswahl über die Filter weiter ein.": "Es werden die ersten {limit} Einträge angezeigt. Grenze die Auswahl über die Filter weiter ein.",
  "Es werden die ersten {limit} Touren angezeigt. Grenze die Auswahl über die Filter weiter ein.": "Es werden die ersten {limit} Touren angezeigt. Grenze die Auswahl über die Filter weiter ein.",
  "Es werden die ersten {limit} Veranstaltungen angezeigt. Grenze die Auswahl über die Filter weiter ein.": "Es werden die ersten {limit} Veranstaltungen angezeigt. Grenze die Auswahl über die Filter weiter ein.",
  "Es wurden keine Benutzer mit der Rolle „admin“ gefunden.": "Es wurden keine Benutzer mit der Rolle „admin“ gefunden.",
  "Externe Schnittstellen, aus denen BELTURO regionale Inhalte importiert": "Externe Schnittstellen, aus denen BELTURO regionale Inhalte importiert",
  "Externe Schnittstellen, aus denen BELTURO regionale Inhalte importiert — derzeit Veranstaltungen, später auch Sehenswürdigkeiten und Gastronomie. Der Import läuft künftig täglich automatisch — hier lässt er sich jederzeit manuell anstoßen.": "Externe Schnittstellen, aus denen BELTURO regionale Inhalte importiert — derzeit Veranstaltungen, später auch Sehenswürdigkeiten und Gastronomie. Der Import läuft künftig täglich automatisch — hier lässt er sich jederzeit manuell anstoßen.",
  "Feature-Flags": "Feature-Flags",
  "Fehler": "Fehler",
  "Fehler beim Laden der Daten": "Fehler beim Laden der Daten",
  "fehlgeschlagen": "fehlgeschlagen",
  "Fels": "Fels",
  "Findet draußen statt (wetterabhängig)": "Findet draußen statt (wetterabhängig)",
  "Firmenname": "Firmenname",
  "Fr": "Fr",
  "Freizeit": "Freizeit",
  "Frühling": "Frühling",
  "Führung": "Führung",
  "Für diese Auswahl liegen keine Daten vor. Der Import läuft über „Datenquellen“.": "Für diese Auswahl liegen keine Daten vor. Der Import läuft über „Datenquellen“.",
  "Galerie": "Galerie",
  "ganztägig": "ganztägig",
  "Gast": "Gast",
  "Gästehaus": "Gästehaus",
  "Gästekonten": "Gästekonten",
  "Gastgeber": "Gastgeber",
  "Gastgeber (Client-Rolle)": "Gastgeber (Client-Rolle)",
  "Gastronomie": "Gastronomie",
  "Gastronomie konnte nicht geladen werden": "Gastronomie konnte nicht geladen werden",
  "Gebannt": "Gebannt",
  "Geeignet für": "Geeignet für",
  "Geotop": "Geotop",
  "Gesamt": "Gesamt",
  "Geschäft": "Geschäft",
  "Geschützter Bereich": "Geschützter Bereich",
  "Gesperrt": "Gesperrt",
  "Ghost-Session konnte nicht gestartet werden.": "Ghost-Session konnte nicht gestartet werden.",
  "Ghost-Session starten": "Ghost-Session starten",
  "Ghost-Session starten?": "Ghost-Session starten?",
  "Glutenfrei": "Glutenfrei",
  "Guests": "Guests",
  "Halal": "Halal",
  "Herbst": "Herbst",
  "Herkunft": "Herkunft",
  "Hilfe & Support": "Hilfe & Support",
  "Hin und zurück": "Hin und zurück",
  "Hinweise": "Hinweise",
  "Historische Stätte": "Historische Stätte",
  "Historischer Kern": "Historischer Kern",
  "Hofladen": "Hofladen",
  "Höhe": "Höhe",
  "Höhle": "Höhle",
  "Home": "Home",
  "Höranlage": "Höranlage",
  "Hostel": "Hostel",
  "Hotel": "Hotel",
  "Hunde erlaubt": "Hunde erlaubt",
  "Import": "Import",
  "Import abgeschlossen — {stats}": "Import abgeschlossen — {stats}",
  "Import fehlgeschlagen. Bitte versuche es später erneut.": "Import fehlgeschlagen. Bitte versuche es später erneut.",
  "Import läuft …": "Import läuft …",
  "Importiert aus „{source}“": "Importiert aus „{source}“",
  "Importierte Veranstaltungen sofort veröffentlichen": "Importierte Veranstaltungen sofort veröffentlichen",
  "in BELTURO gespeichert": "in BELTURO gespeichert",
  "inaktiv": "inaktiv",
  "Info": "Info",
  "Inhalt": "Inhalt",
  "Inhalte": "Inhalte",
  "Interner Operator-Zugang": "Interner Operator-Zugang",
  "Ja": "Ja",
  "Jahreszeiten": "Jahreszeiten",
  "Jetzt importieren": "Jetzt importieren",
  "Kanu": "Kanu",
  "Kategorie": "Kategorie",
  "Kein Konto mit dieser E-Mail-Adresse gefunden.": "Kein Konto mit dieser E-Mail-Adresse gefunden.",
  "Kein Streckenverlauf hinterlegt": "Kein Streckenverlauf hinterlegt",
  "Kein Termin": "Kein Termin",
  "Kein Zugang? Wende dich an die BELTURO-Administration.": "Kein Zugang? Wende dich an die BELTURO-Administration.",
  "Keine Admin-Benutzer": "Keine Admin-Benutzer",
  "Keine Angaben": "Keine Angaben",
  "Keine Benutzer gefunden": "Keine Benutzer gefunden",
  "Keine Berechtigung für diese Aktion.": "Keine Berechtigung für diese Aktion.",
  "Keine Client-Benutzer verfügbar": "Keine Client-Benutzer verfügbar",
  "Keine Datenquellen": "Keine Datenquellen",
  "Keine Datenquellen eingerichtet": "Keine Datenquellen eingerichtet",
  "Keine Dublette — wieder anzeigen": "Keine Dublette — wieder anzeigen",
  "Keine Dublette?": "Keine Dublette?",
  "Keine Einträge": "Keine Einträge",
  "Keine Einträge gefunden": "Keine Einträge gefunden",
  "Keine Gastronomie gefunden": "Keine Gastronomie gefunden",
  "Keine Gastronomie oder Sehenswürdigkeiten innerhalb von {radius} entlang der Strecke.": "Keine Gastronomie oder Sehenswürdigkeiten innerhalb von {radius} entlang der Strecke.",
  "Keine Kartenquelle konfiguriert — der Streckenverlauf wird als Skizze angezeigt. Kachel-URL in config.json unter „map.tileUrl“ hinterlegen.": "Keine Kartenquelle konfiguriert — der Streckenverlauf wird als Skizze angezeigt. Kachel-URL in config.json unter „map.tileUrl“ hinterlegen.",
  "Keine Sehenswürdigkeiten gefunden": "Keine Sehenswürdigkeiten gefunden",
  "Keine Termine hinterlegt.": "Keine Termine hinterlegt.",
  "Keine Touren gefunden": "Keine Touren gefunden",
  "Keine Unterkünfte": "Keine Unterkünfte",
  "Keine Unterkünfte gefunden": "Keine Unterkünfte gefunden",
  "Keine Veranstaltungen gefunden": "Keine Veranstaltungen gefunden",
  "Kennzahlen konnten nicht geladen werden": "Kennzahlen konnten nicht geladen werden",
  "Kennzahlen zu Gastgebern, Unterkünften und den regionalen Inhalten, die allen Gästemappen zugrunde liegen.": "Kennzahlen zu Gastgebern, Unterkünften und den regionalen Inhalten, die allen Gästemappen zugrunde liegen.",
  "KI-Kosten": "KI-Kosten",
  "Kinderwagentauglich": "Kinderwagentauglich",
  "Kino": "Kino",
  "Kirche": "Kirche",
  "Klettern": "Klettern",
  "Kloster": "Kloster",
  "Kontakt": "Kontakt",
  "Konten": "Konten",
  "Koordinaten": "Koordinaten",
  "kopiert · max. {px} px": "kopiert · max. {px} px",
  "Kopiert werden nur Bilder mit einer passenden Lizenz (CC0, CC-BY, CC-BY-SA) — jeweils mit Bildnachweis. Alle anderen bleiben beim Anbieter verlinkt.": "Kopiert werden nur Bilder mit einer passenden Lizenz (CC0, CC-BY, CC-BY-SA) — jeweils mit Bildnachweis. Alle anderen bleiben beim Anbieter verlinkt.",
  "Kritisch": "Kritisch",
  "Küche": "Küche",
  "Küche & Ausstattung": "Küche & Ausstattung",
  "Kultur & Geschichte": "Kultur & Geschichte",
  "Kurztext": "Kurztext",
  "Lade API-Anfragen …": "Lade API-Anfragen …",
  "Lade Benutzer …": "Lade Benutzer …",
  "Lade Datenquellen …": "Lade Datenquellen …",
  "Lade Gastronomie …": "Lade Gastronomie …",
  "Lade Kennzahlen …": "Lade Kennzahlen …",
  "Lade Sehenswürdigkeiten …": "Lade Sehenswürdigkeiten …",
  "Lade Systemprotokoll …": "Lade Systemprotokoll …",
  "Lade Touren …": "Lade Touren …",
  "Lade Unterkünfte …": "Lade Unterkünfte …",
  "Lade Veranstaltungen …": "Lade Veranstaltungen …",
  "Lädt …": "Lädt …",
  "Laktosefrei": "Laktosefrei",
  "Ländercode": "Ländercode",
  "Langlauf": "Langlauf",
  "Laufen": "Laufen",
  "Leer lassen, um beizubehalten": "Leer lassen, um beizubehalten",
  "Leer lassen, um den gespeicherten Schlüssel unverändert zu übernehmen.": "Leer lassen, um den gespeicherten Schlüssel unverändert zu übernehmen.",
  "Leicht": "Leicht",
  "Letzter Import {date} · {status}": "Letzter Import {date} · {status}",
  "Level": "Level",
  "Links & Hervorhebung": "Links & Hervorhebung",
  "Lizenzschlüssel": "Lizenzschlüssel",
  "Löschen": "Löschen",
  "Löschen fehlgeschlagen. Bitte versuche es später erneut.": "Löschen fehlgeschlagen. Bitte versuche es später erneut.",
  "Manuell bearbeitet": "Manuell bearbeitet",
  "Manuell bearbeitet — wird beim Import nicht überschrieben": "Manuell bearbeitet — wird beim Import nicht überschrieben",
  "Maschinell übersetzt": "Maschinell übersetzt",
  "Mausrad-Zoom ist aus, damit der Dialog scrollbar bleibt — nutze die +/− Schaltflächen.": "Mausrad-Zoom ist aus, damit der Dialog scrollbar bleibt — nutze die +/− Schaltflächen.",
  "Max Mustermann": "Max Mustermann",
  "Max. Abrufe": "Max. Abrufe",
  "Maximale Bildkante (px)": "Maximale Bildkante (px)",
  "Mein Profil": "Mein Profil",
  "Melde dich an, um die BELTURO-Plattform zu verwalten.": "Melde dich an, um die BELTURO-Plattform zu verwalten.",
  "Menü öffnen": "Menü öffnen",
  "Methode": "Methode",
  "Mi": "Mi",
  "Mindestens 6 Zeichen": "Mindestens 6 Zeichen",
  "Mit anzeigen": "Mit anzeigen",
  "mit Fehlern": "mit Fehlern",
  "Mittel": "Mittel",
  "Mo": "Mo",
  "Möchtest du wirklich alle Einträge aus „{log}“ unwiderruflich löschen? Diese Aktion kann nicht rückgängig gemacht werden.": "Möchtest du wirklich alle Einträge aus „{log}“ unwiderruflich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
  "Mountainbike": "Mountainbike",
  "Mühle": "Mühle",
  "Museum": "Museum",
  "Musterhotel": "Musterhotel",
  "Musterhotel GmbH": "Musterhotel GmbH",
  "Nach Import": "Nach Import",
  "Nachricht": "Nachricht",
  "Nächste 180 Tage": "Nächste 180 Tage",
  "Nächste 30 Tage": "Nächste 30 Tage",
  "Nächste 90 Tage": "Nächste 90 Tage",
  "Nächster Termin": "Nächster Termin",
  "Name": "Name",
  "Name des Ortes": "Name des Ortes",
  "Natur": "Natur",
  "Naturinformation": "Naturinformation",
  "Natursehenswürdigkeit": "Natursehenswürdigkeit",
  "Neue Unterkunft anlegen": "Neue Unterkunft anlegen",
  "Neuen Admin anlegen": "Neuen Admin anlegen",
  "Neuen Client anlegen": "Neuen Client anlegen",
  "Nicht verifiziert": "Nicht verifiziert",
  "noch kein Import": "noch kein Import",
  "Noch kein Import gelaufen": "Noch kein Import gelaufen",
  "Noch keine Feeds eingerichtet.": "Noch keine Feeds eingerichtet.",
  "Noch keine Übersetzungen vorhanden.": "Noch keine Übersetzungen vorhanden.",
  "noch nicht hinterlegt": "noch nicht hinterlegt",
  "noch nie": "noch nie",
  "Nur Dubletten": "Nur Dubletten",
  "Nur Kleinbuchstaben, Ziffern und Bindestriche. Muss eindeutig sein.": "Nur Kleinbuchstaben, Ziffern und Bindestriche. Muss eindeutig sein.",
  "Nur veröffentlichte Unterkünfte sind für Gäste sichtbar (Guest-App & Gästemappe).": "Nur veröffentlichte Unterkünfte sind für Gäste sichtbar (Guest-App & Gästemappe).",
  "Öffnungszeiten": "Öffnungszeiten",
  "Ohne Angabe": "Ohne Angabe",
  "ohne Begrenzung": "ohne Begrenzung",
  "Operator": "Operator",
  "Original": "Original",
  "Original ansehen": "Original ansehen",
  "Ort": "Ort",
  "Park & Garten": "Park & Garten",
  "Parkmöglichkeit": "Parkmöglichkeit",
  "Parkplätze": "Parkplätze",
  "Passwort": "Passwort",
  "Passwort anzeigen": "Passwort anzeigen",
  "Passwort verbergen": "Passwort verbergen",
  "Passwort vergessen?": "Passwort vergessen?",
  "Pfad": "Pfad",
  "Pilgerweg": "Pilgerweg",
  "Plattform-Administratoren": "Plattform-Administratoren",
  "Plattform-Operator": "Plattform-Operator",
  "Plattform-Pool, ohne Duplikate": "Plattform-Pool, ohne Duplikate",
  "Plattform-Status auf einen Blick": "Plattform-Status auf einen Blick",
  "Plattform-Verwaltung": "Plattform-Verwaltung",
  "PLZ": "PLZ",
  "Preis": "Preis",
  "Preisangabe": "Preisangabe",
  "Preisniveau": "Preisniveau",
  "Protokoll konnte nicht geladen werden": "Protokoll konnte nicht geladen werden",
  "Protokolle": "Protokolle",
  "Quelle": "Quelle",
  "Quelle aktiv — wird beim täglichen Import berücksichtigt": "Quelle aktiv — wird beim täglichen Import berücksichtigt",
  "Quellen werden zusammen mit ihrem Importer ausgeliefert.": "Quellen werden zusammen mit ihrem Importer ausgeliefert.",
  "Radfahren": "Radfahren",
  "Rechnungen": "Rechnungen",
  "Redaktionell gepflegte Veranstaltung der Plattform": "Redaktionell gepflegte Veranstaltung der Plattform",
  "Region": "Region",
  "Regional": "Regional",
  "Regionale Inhalte": "Regionale Inhalte",
  "Regionale Veranstaltungen der Plattform": "Regionale Veranstaltungen der Plattform",
  "Reiten": "Reiten",
  "Rennrad": "Rennrad",
  "Reservieren": "Reservieren",
  "Reservierung": "Reservierung",
  "Restaurant": "Restaurant",
  "Restaurants, Cafés und Bars der Region": "Restaurants, Cafés und Bars der Region",
  "Rolle entfernen": "Rolle entfernen",
  "Rolle:": "Rolle:",
  "Rollen": "Rollen",
  "Rollstuhlgerecht": "Rollstuhlgerecht",
  "Ruine": "Ruine",
  "Rundweg": "Rundweg",
  "Rundweg — zurück zum Start": "Rundweg — zurück zum Start",
  "Sa": "Sa",
  "Sächsische Schweiz": "Sächsische Schweiz",
  "Schätzung nach Listenpreis": "Schätzung nach Listenpreis",
  "Schließen": "Schließen",
  "Schlüssel, Adapter und Inhaltstyp sind fest — an ihnen hängen alle bereits importierten Datensätze.": "Schlüssel, Adapter und Inhaltstyp sind fest — an ihnen hängen alle bereits importierten Datensätze.",
  "Schneeschuh": "Schneeschuh",
  "Schotter": "Schotter",
  "Schwer": "Schwer",
  "Schwierigkeit": "Schwierigkeit",
  "See": "See",
  "Sehenswertes": "Sehenswertes",
  "Sehenswürdigkeit": "Sehenswürdigkeit",
  "Sehenswürdigkeiten": "Sehenswürdigkeiten",
  "Sehenswürdigkeiten konnten nicht geladen werden": "Sehenswürdigkeiten konnten nicht geladen werden",
  "Sehr schwer": "Sehr schwer",
  "Seitenleiste ein-/ausklappen": "Seitenleiste ein-/ausklappen",
  "Service": "Service",
  "Sicherheit": "Sicherheit",
  "Sitzplätze": "Sitzplätze",
  "Slug": "Slug",
  "Slug (Subdomain)": "Slug (Subdomain)",
  "So": "So",
  "Sommer": "Sommer",
  "Sonstige": "Sonstige",
  "Sonstiges": "Sonstiges",
  "Spazieren": "Spazieren",
  "Speichern": "Speichern",
  "Speichern fehlgeschlagen. Bitte versuche es später erneut.": "Speichern fehlgeschlagen. Bitte versuche es später erneut.",
  "Spezialitäten": "Spezialitäten",
  "Spielplatz": "Spielplatz",
  "Sport": "Sport",
  "Sprache": "Sprache",
  "Stadt": "Stadt",
  "Stadtrundgang": "Stadtrundgang",
  "Stadtteil": "Stadtteil",
  "Start": "Start",
  "Start & Ziel": "Start & Ziel",
  "Startadresse": "Startadresse",
  "Status": "Status",
  "Straße": "Straße",
  "Straße & Nr.": "Straße & Nr.",
  "Streckentour": "Streckentour",
  "Streckenverlauf": "Streckenverlauf",
  "Stufenlos": "Stufenlos",
  "Suchen …": "Suchen …",
  "Synchronisieren": "Synchronisieren",
  "System": "System",
  "System- und API-Protokolle": "System- und API-Protokolle",
  "Systemprotokoll": "Systemprotokoll",
  "Systemzustand": "Systemzustand",
  "Telefon": "Telefon",
  "Telefon (optional)": "Telefon (optional)",
  "Termine": "Termine",
  "Theater & Bühne": "Theater & Bühne",
  "Ticket-Link": "Ticket-Link",
  "Titel": "Titel",
  "Titelbild": "Titelbild",
  "Tour": "Tour",
  "Tour konnte nicht geladen werden.": "Tour konnte nicht geladen werden.",
  "Touren": "Touren",
  "Touren konnten nicht geladen werden": "Touren konnten nicht geladen werden",
  "Tourist-Information": "Tourist-Information",
  "Track herunterladen": "Track herunterladen",
  "Typ": "Typ",
  "Übersetzungen": "Übersetzungen",
  "Übersicht": "Übersicht",
  "Übersicht.": "Übersicht.",
  "Um den Mittelpunkt der Region. Leer = alles übernehmen.": "Um den Mittelpunkt der Region. Leer = alles übernehmen.",
  "Umkreis": "Umkreis",
  "Umkreis (km)": "Umkreis (km)",
  "unbekannt": "unbekannt",
  "unbekannter Quelle": "unbekannter Quelle",
  "Ungültige Eingabe.": "Ungültige Eingabe.",
  "Ungültiger Slug. Erlaubt: Kleinbuchstaben, Ziffern, Bindestriche.": "Ungültiger Slug. Erlaubt: Kleinbuchstaben, Ziffern, Bindestriche.",
  "Untergrund": "Untergrund",
  "Unterkunft „{name}“ wurde aktualisiert.": "Unterkunft „{name}“ wurde aktualisiert.",
  "Unterkunft „{name}“ wurde angelegt.": "Unterkunft „{name}“ wurde angelegt.",
  "Unterkunft bearbeiten": "Unterkunft bearbeiten",
  "Unterkunft wurde nicht gefunden.": "Unterkunft wurde nicht gefunden.",
  "Unterkunft-Details": "Unterkunft-Details",
  "Unterkünfte": "Unterkünfte",
  "Unterkünfte konnten nicht geladen werden": "Unterkünfte konnten nicht geladen werden",
  "Unterkünfte veröffentlicht": "Unterkünfte veröffentlicht",
  "Unterkünften": "Unterkünften",
  "Untertitel": "Untertitel",
  "Vegan": "Vegan",
  "Vegetarisch": "Vegetarisch",
  "Veranstaltung bearbeiten": "Veranstaltung bearbeiten",
  "Veranstaltung konnte nicht geladen werden.": "Veranstaltung konnte nicht geladen werden.",
  "Veranstaltungen": "Veranstaltungen",
  "Veranstaltungen konnten nicht geladen werden": "Veranstaltungen konnten nicht geladen werden",
  "Veranstaltungen, die eine andere Quelle bereits geliefert hat, werden erkannt (Titel, Datum und Ort) und Gästen nur einmal angezeigt. Beide Datensätze bleiben erhalten.": "Veranstaltungen, die eine andere Quelle bereits geliefert hat, werden erkannt (Titel, Datum und Ort) und Gästen nur einmal angezeigt. Beide Datensätze bleiben erhalten.",
  "Veranstaltungsort": "Veranstaltungsort",
  "Verbindung": "Verbindung",
  "Vergangene einschließen": "Vergangene einschließen",
  "Verkehr": "Verkehr",
  "Verknüpfter Eintrag": "Verknüpfter Eintrag",
  "verlinkt": "verlinkt",
  "Veröffentlichen": "Veröffentlichen",
  "veröffentlicht": "veröffentlicht",
  "Veröffentlicht": "Veröffentlicht",
  "Veröffentlicht — in der Gäste-App sichtbar": "Veröffentlicht — in der Gäste-App sichtbar",
  "Verschoben": "Verschoben",
  "Verteilung": "Verteilung",
  "Vertex AI · letzte 3 Monate": "Vertex AI · letzte 3 Monate",
  "Verwalten": "Verwalten",
  "Viele Regionen.": "Viele Regionen.",
  "von": "von",
  "Wander-, Rad- und Themenwege der Region": "Wander-, Rad- und Themenwege der Region",
  "Wandern": "Wandern",
  "Warnung": "Warnung",
  "Wasserfall": "Wasserfall",
  "WC": "WC",
  "Webseite": "Webseite",
  "Webseite (optional)": "Webseite (optional)",
  "Website": "Website",
  "Wegbeschaffenheit": "Wegbeschaffenheit",
  "Wegpunkt": "Wegpunkt",
  "Wegpunkte": "Wegpunkte",
  "Weingut": "Weingut",
  "Weiter": "Weiter",
  "Wellness & Sauna": "Wellness & Sauna",
  "Wieder anzeigen": "Wieder anzeigen",
  "Wieder mit der Quelle synchronisieren": "Wieder mit der Quelle synchronisieren",
  "Wieder mit der Quelle synchronisieren?": "Wieder mit der Quelle synchronisieren?",
  "Wiese": "Wiese",
  "Willkommen zurück": "Willkommen zurück",
  "Winter": "Winter",
  "Winterwandern": "Winterwandern",
  "Zeige": "Zeige",
  "Zeitpunkt": "Zeitpunkt",
  "Zeitraum": "Zeitraum",
  "Zeitraum (Monate)": "Zeitraum (Monate)",
  "Zeitzone": "Zeitzone",
  "Ziel": "Ziel",
  "Zoo & Tierpark": "Zoo & Tierpark",
  "Zugang verweigert. Prüfe deine Zugangsdaten oder Berechtigung.": "Zugang verweigert. Prüfe deine Zugangsdaten oder Berechtigung.",
  "zuletzt abgeglichen {date}": "zuletzt abgeglichen {date}",
  "Zuletzt geändert": "Zuletzt geändert",
  "Zuletzt synchronisiert": "Zuletzt synchronisiert",
  "Zurück": "Zurück",
  "Zurück zur Anmeldung": "Zurück zur Anmeldung",
  "Zurückziehen": "Zurückziehen",
  "Nutzung der Gäste-Apps aller Unterkünfte": "Nutzung der Gäste-Apps aller Unterkünfte",
  "Lade Analytics …": "Lade Analytics …",
  "Analytics konnten nicht geladen werden.": "Analytics konnten nicht geladen werden.",
  "{days} Tage": "{days} Tage",
  "Besucher": "Besucher",
  "Besuche": "Besuche",
  "Seitenaufrufe": "Seitenaufrufe",
  "Aktive Unterkünfte": "Aktive Unterkünfte",
  "mit Besuchern im Zeitraum": "mit Besuchern im Zeitraum",
  "Besucher pro Woche": "Besucher pro Woche",
  "Besucher pro Tag": "Besucher pro Tag",
  "Besucher im Zeitverlauf": "Besucher im Zeitverlauf",
  "Ø Besucher pro Wochentag": "Ø Besucher pro Wochentag",
  "Besucher nach Uhrzeit": "Besucher nach Uhrzeit",
  "{n} Aufrufe": "{n} Aufrufe",
  "Gelöschte Unterkunft": "Gelöschte Unterkunft",
  "Kein Vergleich zum Vorzeitraum": "Kein Vergleich zum Vorzeitraum",
  "Noch keine Daten": "Noch keine Daten",
  "Wie im Vorzeitraum": "Wie im Vorzeitraum",
  "{change} zum Vorzeitraum": "{change} zum Vorzeitraum",
  "Woche ab {date}": "Woche ab {date}",
  "{from}–{to} Uhr": "{from}–{to} Uhr",
  "Startseite": "Startseite",
  "Gästemappe": "Gästemappe",
  "Empfehlungen": "Empfehlungen",
  "Aufenthaltsplaner": "Aufenthaltsplaner",
  "Chat": "Chat",
  "Umfragen": "Umfragen",
  "Wellness": "Wellness",
  "Noch keine Nutzungsdaten in diesem Zeitraum. Die Zahlen werden stündlich aus den Gäste-Apps verdichtet.": "Noch keine Nutzungsdaten in diesem Zeitraum. Die Zahlen werden stündlich aus den Gäste-Apps verdichtet.",
  "Meistgenutzte Unterkünfte": "Meistgenutzte Unterkünfte",
  "Unterkunft": "Unterkunft",
  "Beliebteste Bereiche": "Beliebteste Bereiche",
  "Noch keine Aufrufe.": "Noch keine Aufrufe.",
  "Anonym gezählt, ein Besucher je Tag und Unterkunft. Uhrzeit und Tag in der Zeitzone der jeweiligen Unterkunft.": "Anonym gezählt, ein Besucher je Tag und Unterkunft. Uhrzeit und Tag in der Zeitzone der jeweiligen Unterkunft.",
  "Stand: {date}": "Stand: {date}",
  "bis jetzt": "bis jetzt",
  "Lade Gästekonten …": "Lade Gästekonten …",
  "Gästekonten konnten nicht geladen werden": "Gästekonten konnten nicht geladen werden",
  "E-Mail bestätigt": "E-Mail bestätigt",
  "In einer Unterkunft angemeldet": "In einer Unterkunft angemeldet",
  "Haben geschrieben": "Haben geschrieben",
  "Nachrichten": "Nachrichten",
  "Pläne": "Pläne",
  "Zuletzt aktiv": "Zuletzt aktiv",
  "Registriert": "Registriert",
  "Keine Gästekonten gefunden": "Keine Gästekonten gefunden",
  "Registrierte Gäste der Plattform": "Registrierte Gäste der Plattform",
  "Lade Gästekonto …": "Lade Gästekonto …",
  "Gästekonto nicht gefunden": "Gästekonto nicht gefunden",
  "Gästekonto konnte nicht geladen werden": "Gästekonto konnte nicht geladen werden",
  "Dieses Konto gibt es nicht (mehr) oder es ist kein Gästekonto.": "Dieses Konto gibt es nicht (mehr) oder es ist kein Gästekonto.",
  "Alle Gästekonten": "Alle Gästekonten",
  "Gästekonto": "Gästekonto",
  "Per Link": "Per Link",
  "Per QR-Code": "Per QR-Code",
  "Im Chat": "Im Chat",
  "Aus der Gäste-App": "Aus der Gäste-App",
  "Per Benachrichtigung": "Per Benachrichtigung",
  "Konto-ID": "Konto-ID",
  "Nachrichten vom Gast": "Nachrichten vom Gast",
  "Pläne im Planer": "Pläne im Planer",
  "Umfrage-Einladungen": "Umfrage-Einladungen",
  "Chat-Verlauf": "Chat-Verlauf",
  "Dieser Gast hat noch mit keiner Unterkunft gechattet.": "Dieser Gast hat noch mit keiner Unterkunft gechattet.",
  "Chat mit {house}": "Chat mit {house}",
  "{count} ungelesen": "{count} ungelesen",
  "Noch keine Nachrichten.": "Noch keine Nachrichten.",
  "KI-Concierge": "KI-Concierge",
  "Noch in keiner Unterkunft angemeldet.": "Noch in keiner Unterkunft angemeldet.",
  "Erstmals {first} · zuletzt {last}": "Erstmals {first} · zuletzt {last}",
  "Aufenthalte (Planer)": "Aufenthalte (Planer)",
  "Noch keinen Aufenthalt im Planer angelegt.": "Noch keinen Aufenthalt im Planer angelegt.",
  "{count} Einträge": "{count} Einträge",
  "Umfragen & Bewertungen": "Umfragen & Bewertungen",
  "Keine Umfrage-Einladungen.": "Keine Umfrage-Einladungen.",
  "Abgeschlossen": "Abgeschlossen",
  "Geöffnet": "Geöffnet",
  "Gesendet": "Gesendet",
  "Antworten werden nicht pro Gast angezeigt: Die Gäste-App sichert zu, dass Bewertungen für den Gastgeber anonym sind.": "Antworten werden nicht pro Gast angezeigt: Die Gäste-App sichert zu, dass Bewertungen für den Gastgeber anonym sind.",
  "Dein Konto": "Dein Konto",
  "Das neue Passwort muss sich vom aktuellen unterscheiden.": "Das neue Passwort muss sich vom aktuellen unterscheiden.",
  "Die Passwörter stimmen nicht überein.": "Die Passwörter stimmen nicht überein.",
  "Dein Passwort wurde geändert.": "Dein Passwort wurde geändert.",
  "Das aktuelle Passwort stimmt nicht.": "Das aktuelle Passwort stimmt nicht.",
  "Das Passwort konnte nicht geändert werden. Bitte versuche es später erneut.": "Das Passwort konnte nicht geändert werden. Bitte versuche es später erneut.",
  "Konto seit": "Konto seit",
  "Passwort ändern": "Passwort ändern",
  "Aktuelles Passwort": "Aktuelles Passwort",
  "Neues Passwort": "Neues Passwort",
  "Mindestens {count} Zeichen.": "Mindestens {count} Zeichen.",
  "Neues Passwort wiederholen": "Neues Passwort wiederholen",
  "Bestehende Anmeldungen bleiben aktiv.": "Bestehende Anmeldungen bleiben aktiv.",
  "Manuell verifizieren": "Manuell verifizieren",
  "Gästekonto verifizieren?": "Gästekonto verifizieren?",
  "„{email}“ wird als bestätigt markiert, ohne dass der Gast den Link aus der Bestätigungs-E-Mail geöffnet hat.": "„{email}“ wird als bestätigt markiert, ohne dass der Gast den Link aus der Bestätigungs-E-Mail geöffnet hat.",
  "Verifizieren": "Verifizieren",
  "„{name}“ ist jetzt verifiziert.": "„{name}“ ist jetzt verifiziert.",
  "Dieses Konto wartet nicht (mehr) auf eine Verifizierung.": "Dieses Konto wartet nicht (mehr) auf eine Verifizierung.",
  "Das Konto konnte nicht verifiziert werden. Bitte versuche es später erneut.": "Das Konto konnte nicht verifiziert werden. Bitte versuche es später erneut.",
  "Der Link konnte nicht angefordert werden. Bitte versuche es später erneut.": "Der Link konnte nicht angefordert werden. Bitte versuche es später erneut.",
  "Falls zu {email} ein Konto existiert, haben wir dir einen Link zum Zurücksetzen geschickt. Er ist 2 Stunden gültig.": "Falls zu {email} ein Konto existiert, haben wir dir einen Link zum Zurücksetzen geschickt. Er ist 2 Stunden gültig.",
  "Gib die E-Mail-Adresse deines Kontos ein. Wir schicken dir einen Link, mit dem du ein neues Passwort vergeben kannst.": "Gib die E-Mail-Adresse deines Kontos ein. Wir schicken dir einen Link, mit dem du ein neues Passwort vergeben kannst.",
  "Link anfordern": "Link anfordern",
  "Schau in dein Postfach": "Schau in dein Postfach",
  "Keine E-Mail erhalten? Prüfe deinen Spam-Ordner oder fordere den Link erneut an.": "Keine E-Mail erhalten? Prüfe deinen Spam-Ordner oder fordere den Link erneut an.",
  "Dieser Link ist unvollständig.": "Dieser Link ist unvollständig.",
  "Dieser Link wurde bereits verwendet oder ist nicht mehr gültig.": "Dieser Link wurde bereits verwendet oder ist nicht mehr gültig.",
  "Dieser Link ist abgelaufen. Bitte fordere einen neuen an.": "Dieser Link ist abgelaufen. Bitte fordere einen neuen an.",
  "Dieser Link kann hier nicht verwendet werden.": "Dieser Link kann hier nicht verwendet werden.",
  "Link ungültig": "Link ungültig",
  "Link wird geprüft …": "Link wird geprüft …",
  "Neues Passwort vergeben": "Neues Passwort vergeben",
  "Wähle ein neues Passwort für dein Konto.": "Wähle ein neues Passwort für dein Konto.",
  "Passwort speichern": "Passwort speichern",
  "Passwort geändert": "Passwort geändert",
  "Dein neues Passwort ist gespeichert. Aus Sicherheitsgründen wurdest du auf allen Geräten abgemeldet.": "Dein neues Passwort ist gespeichert. Aus Sicherheitsgründen wurdest du auf allen Geräten abgemeldet.",
  "Zur Anmeldung": "Zur Anmeldung",
  "Push-Nachrichten": "Push-Nachrichten",
  "Benachrichtigungen an die Gäste aller Unterkünfte": "Benachrichtigungen an die Gäste aller Unterkünfte",
  "Startseite der Gäste-App": "Startseite der Gäste-App",
  "Region entdecken": "Region entdecken",
  "Lade Push-Nachrichten …": "Lade Push-Nachrichten …",
  "Die Push-Nachrichten konnten nicht geladen werden. Bitte versuche es später erneut.": "Die Push-Nachrichten konnten nicht geladen werden. Bitte versuche es später erneut.",
  "Alle Unterkünfte": "Alle Unterkünfte",
  "{count} Unterkünfte ausgewählt.": {
    "one": "{count} Unterkunft ausgewählt.",
    "other": "{count} Unterkünfte ausgewählt."
  },
  "Erreicht bis zu {count} Geräte": {
    "one": "Erreicht bis zu {count} Gerät",
    "other": "Erreicht bis zu {count} Geräte"
  },
  "Titel der Nachricht": "Titel der Nachricht",
  "Hier steht dein Text.": "Hier steht dein Text.",
  "Bitte gib einen Titel und eine Nachricht ein.": "Bitte gib einen Titel und eine Nachricht ein.",
  "Bitte wähle mindestens eine Unterkunft aus.": "Bitte wähle mindestens eine Unterkunft aus.",
  "Nachricht an die Gäste senden?": "Nachricht an die Gäste senden?",
  "Die Nachricht geht sofort an alle {count} Geräte aller Unterkünfte. Das lässt sich nicht zurücknehmen.": "Die Nachricht geht sofort an alle {count} Geräte aller Unterkünfte. Das lässt sich nicht zurücknehmen.",
  "Die Nachricht geht sofort an {count} Geräte in {houses} Unterkünften. Das lässt sich nicht zurücknehmen.": "Die Nachricht geht sofort an {count} Geräte in {houses} Unterkünften. Das lässt sich nicht zurücknehmen.",
  "Senden": "Senden",
  "Kein Gerät hat Benachrichtigungen eingeschaltet — die Nachricht ging an niemanden.": "Kein Gerät hat Benachrichtigungen eingeschaltet — die Nachricht ging an niemanden.",
  "{sent} von {count} Geräten erreicht, {failed} fehlgeschlagen.": "{sent} von {count} Geräten erreicht, {failed} fehlgeschlagen.",
  "Nachricht an {count} Geräte gesendet.": {
    "one": "Nachricht an {count} Gerät gesendet.",
    "other": "Nachricht an {count} Geräte gesendet."
  },
  "Bitte überprüfe Titel und Nachricht.": "Bitte überprüfe Titel und Nachricht.",
  "Die Nachricht konnte nicht gesendet werden. Bitte versuche es später erneut.": "Die Nachricht konnte nicht gesendet werden. Bitte versuche es später erneut.",
  "Web Push ist in dieser Umgebung nicht aktiv (services.webPush in der core-api-Konfiguration). Nachrichten werden nicht zugestellt.": "Web Push ist in dieser Umgebung nicht aktiv (services.webPush in der core-api-Konfiguration). Nachrichten werden nicht zugestellt.",
  "Geräte mit Benachrichtigungen": "Geräte mit Benachrichtigungen",
  "Davon mit Gäste-Konto": "Davon mit Gäste-Konto",
  "Unterkünfte mit Geräten": "Unterkünfte mit Geräten",
  "von {count}": "von {count}",
  "Nachricht an die Gäste": "Nachricht an die Gäste",
  "z. B. Neu in deiner Gäste-App: der Aufenthaltsplaner": "z. B. Neu in deiner Gäste-App: der Aufenthaltsplaner",
  "Die Nachricht kommt im Namen des jeweiligen Hauses an — schreib sie so, dass sie zu jedem Haus passt.": "Die Nachricht kommt im Namen des jeweiligen Hauses an — schreib sie so, dass sie zu jedem Haus passt.",
  "Beim Antippen öffnen": "Beim Antippen öffnen",
  "{count} Geräte": {
    "one": "{count} Gerät",
    "other": "{count} Geräte"
  },
  "Ausgewählte Unterkünfte": "Ausgewählte Unterkünfte",
  "Unterkunft suchen …": "Unterkunft suchen …",
  "Alle mit Geräten": "Alle mit Geräten",
  "Keine": "Keine",
  "Vorschau": "Vorschau",
  "Name der Unterkunft": "Name der Unterkunft",
  "jetzt": "jetzt",
  "Verlauf": "Verlauf",
  "Noch keine Plattform-Nachricht gesendet. Nachrichten, die Gastgeber selbst an ihr Haus schicken, stehen hier nicht.": "Noch keine Plattform-Nachricht gesendet. Nachrichten, die Gastgeber selbst an ihr Haus schicken, stehen hier nicht.",
  "{count} zugestellt": "{count} zugestellt",
  "{count} fehlgeschlagen": "{count} fehlgeschlagen",
  "{count} abgemeldet": "{count} abgemeldet",
  "KI-Kosten im Detail": "KI-Kosten im Detail",
  "Vertex AI · Plattform und Gastgeber": "Vertex AI · Plattform und Gastgeber",
  "Lade KI-Kosten …": "Lade KI-Kosten …",
  "KI-Kosten konnten nicht geladen werden": "KI-Kosten konnten nicht geladen werden",
  "Monat": "Monat",
  "Schätzung nach Listenpreis · 1 $ = {rate} €": "Schätzung nach Listenpreis · 1 $ = {rate} €",
  "Diesen Monat": "Diesen Monat",
  "Vormonat": "Vormonat",
  "kein Vergleich zum Vormonat": "kein Vergleich zum Vormonat",
  "{delta} ggü. Vormonat ({previous})": "{delta} ggü. Vormonat ({previous})",
  "Prognose Monatsende": "Prognose Monatsende",
  "Prognose {amount}": "Prognose {amount}",
  "{count} Anfragen bisher": {
    "one": "{n} Anfrage bisher",
    "other": "{n} Anfragen bisher"
  },
  "{n} fehlgeschlagen": "{n} fehlgeschlagen",
  "Gastgeber / Plattform": "Gastgeber / Plattform",
  "{count} Gastgeber mit KI-Kosten": {
    "one": "{n} Gastgeber mit KI-Kosten",
    "other": "{n} Gastgeber mit KI-Kosten"
  },
  "{count} Gastgeber mit KI-Kosten in diesem Monat": {
    "one": "{n} Gastgeber mit KI-Kosten in diesem Monat",
    "other": "{n} Gastgeber mit KI-Kosten in diesem Monat"
  },
  "{shown} von {count} Gastgebern mit KI-Kosten · die übrigen zusammen {rest}": "{shown} von {count} Gastgebern mit KI-Kosten · die übrigen zusammen {rest}",
  "Letzte 12 Monate": "Letzte 12 Monate",
  "12 Monate": "12 Monate",
  "Letzte 60 Tage": "Letzte 60 Tage",
  "Kosten pro Monat": "Kosten pro Monat",
  "Kosten pro Tag": "Kosten pro Tag",
  "7-Tage-Schnitt": "7-Tage-Schnitt",
  "Aufteilung": "Aufteilung",
  "Nach Funktion": "Nach Funktion",
  "Nach Modell": "Nach Modell",
  "Nach Unterkunft": "Nach Unterkunft",
  "Top 10 Gastgeber": "Top 10 Gastgeber",
  "In diesem Monat hatte kein Gastgeber KI-Kosten.": "In diesem Monat hatte kein Gastgeber KI-Kosten.",
  "Gastgeber ohne Namen": "Gastgeber ohne Namen",
  "Kosten": "Kosten",
  "Monatsbudget": "Monatsbudget",
  "Anteil": "Anteil",
  "{percent} von {budget}": "{percent} von {budget}",
  "Plattform": "Plattform",
  "Plattform-eigene Kosten": "Plattform-eigene Kosten",
  "Importe, nächtliche Übersetzungen, Einrichtung bei Registrierung": "Importe, nächtliche Übersetzungen, Einrichtung bei Registrierung",
  "im Monat": "im Monat",
  "Keine KI-Anfragen in diesem Monat.": "Keine KI-Anfragen in diesem Monat.",
  "Noch keine KI-Anfragen.": "Noch keine KI-Anfragen.",
  "Modelle": "Modelle",
  "Modell": "Modell",
  "{input} Eingabe- und {output} Ausgabe-Tokens": "{input} Eingabe- und {output} Ausgabe-Tokens",
  "Alle KI-Kosten": "Alle KI-Kosten",
  "Gastgeber nicht gefunden": "Gastgeber nicht gefunden",
  "Diesen Gastgeber gibt es nicht (mehr).": "Diesen Gastgeber gibt es nicht (mehr).",
  "Alle KI-Anfragen ohne Gastgeber: Importe, nächtliche Übersetzungen und die Einrichtung neuer Unterkünfte bei der Registrierung. Diese Kosten trägt BELTURO, sie zählen gegen kein Gastgeber-Budget.": "Alle KI-Anfragen ohne Gastgeber: Importe, nächtliche Übersetzungen und die Einrichtung neuer Unterkünfte bei der Registrierung. Diese Kosten trägt BELTURO, sie zählen gegen kein Gastgeber-Budget.",
  "Budget diesen Monat": "Budget diesen Monat",
  "{percent} verbraucht": "{percent} verbraucht",
  "Budget aufgebraucht": "Budget aufgebraucht",
  "noch {remaining} frei": "noch {remaining} frei",
  "Ø Kosten pro Anfrage": "Ø Kosten pro Anfrage",
  "Ohne Unterkunft": "Ohne Unterkunft",
  "Letzte Anfragen": "Letzte Anfragen",
  "die neuesten {count}": "die neuesten {count}",
  "Funktion": "Funktion",
  "Tokens ein / aus": "Tokens ein / aus",
  "Übersetzung": "Übersetzung",
  "Concierge: Dokumente lesen": "Concierge: Dokumente lesen",
  "Einrichtung bei Registrierung": "Einrichtung bei Registrierung",
  "Gelöschter Gastgeber": "Gelöschter Gastgeber",
  "Diesen Gastgeber gibt es nicht mehr (z. B. eine nicht abgeschlossene Registrierung). Seine KI-Anfragen bleiben in der Kostenaufstellung.": "Diesen Gastgeber gibt es nicht mehr (z. B. eine nicht abgeschlossene Registrierung). Seine KI-Anfragen bleiben in der Kostenaufstellung.",
  "Ausgangspunkt aller Entfernungen in der Gäste-App; die Koordinaten werden beim Speichern ermittelt.": "Ausgangspunkt aller Entfernungen in der Gäste-App; die Koordinaten werden beim Speichern ermittelt.",
  "Bitte gib Straße und Hausnummer ein.": "Bitte gib Straße und Hausnummer ein.",
  "Bitte gib die PLZ ein.": "Bitte gib die PLZ ein.",
  "Bitte gib den Ort ein.": "Bitte gib den Ort ein.",
  "Löschen ist gerade nicht möglich. Bitte versuche es später erneut.": "Löschen ist gerade nicht möglich. Bitte versuche es später erneut.",
  "Unterkunft endgültig löschen?": "Unterkunft endgültig löschen?",
  "„{name}“ wird mit allen zugehörigen Daten unwiderruflich gelöscht — auch die Gäste-App unter {slug} ist danach nicht mehr erreichbar.": "„{name}“ wird mit allen zugehörigen Daten unwiderruflich gelöscht — auch die Gäste-App unter {slug} ist danach nicht mehr erreichbar.",
  "Dabei werden gelöscht:": "Dabei werden gelöscht:",
  "Gastgeber ebenfalls löschen?": "Gastgeber ebenfalls löschen?",
  "„{name}“ ist die letzte Unterkunft von {owner}. Das Gastgeber-Konto wird deshalb ebenfalls gelöscht — samt Anmeldungen, und die Organisation, sobald sie leer ist.": "„{name}“ ist die letzte Unterkunft von {owner}. Das Gastgeber-Konto wird deshalb ebenfalls gelöscht — samt Anmeldungen, und die Organisation, sobald sie leer ist.",
  "„{name}“ ist die letzte Unterkunft von {owner}. Das Konto hat weitere Rollen und bleibt bestehen; es verliert nur die Client-Rolle.": "„{name}“ ist die letzte Unterkunft von {owner}. Das Konto hat weitere Rollen und bleibt bestehen; es verliert nur die Client-Rolle.",
  "Unterkunft und Gastgeber löschen": "Unterkunft und Gastgeber löschen",
  "Löschen und Rolle entfernen": "Löschen und Rolle entfernen",
  "Unterkunft „{name}“ und ihr Gastgeber wurden gelöscht.": "Unterkunft „{name}“ und ihr Gastgeber wurden gelöscht.",
  "Unterkunft „{name}“ wurde gelöscht.": "Unterkunft „{name}“ wurde gelöscht.",
  "Unterkünfte:": "Unterkünfte:",
  "Gastgeber endgültig löschen?": "Gastgeber endgültig löschen?",
  "{count} Gästemappe-Module": {
    "one": "{count} Gästemappe-Modul",
    "other": "{count} Gästemappe-Module"
  },
  "{count} eigene Veranstaltungen": {
    "one": "{count} eigene Veranstaltung",
    "other": "{count} eigene Veranstaltungen"
  },
  "{count} eigene Orte": {
    "one": "{count} eigener Ort",
    "other": "{count} eigene Orte"
  },
  "{count} eigene Touren": {
    "one": "{count} eigene Tour",
    "other": "{count} eigene Touren"
  },
  "{count} Chat-Verläufe mit Gästen": {
    "one": "{count} Chat-Verlauf mit Gästen",
    "other": "{count} Chat-Verläufe mit Gästen"
  },
  "{count} Umfragen": {
    "one": "{count} Umfrage",
    "other": "{count} Umfragen"
  },
  "{count} Umfrage-Antworten": {
    "one": "{count} Umfrage-Antwort",
    "other": "{count} Umfrage-Antworten"
  },
  "{count} Reisepläne von Gästen": {
    "one": "{count} Reiseplan von Gästen",
    "other": "{count} Reisepläne von Gästen"
  },
  "{count} Push-Abonnements": {
    "one": "{count} Push-Abonnement",
    "other": "{count} Push-Abonnements"
  },
  "{count} Push-Nachrichten": {
    "one": "{count} Push-Nachricht",
    "other": "{count} Push-Nachrichten"
  },
  "{count} Concierge-Dokumente": {
    "one": "{count} Concierge-Dokument",
    "other": "{count} Concierge-Dokumente"
  },
  "{count} Gast-Verknüpfungen": {
    "one": "{count} Gast-Verknüpfung",
    "other": "{count} Gast-Verknüpfungen"
  },
  "{count} Gastkonten ohne weitere Unterkunft": {
    "one": "{count} Gastkonto ohne weitere Unterkunft",
    "other": "{count} Gastkonten ohne weitere Unterkunft"
  },
  "dieses Gastkonto": "dieses Gastkonto",
  "Gastkonto endgültig löschen?": "Gastkonto endgültig löschen?",
  "Gast-Rolle entfernen?": "Gast-Rolle entfernen?",
  "„{name}“ hat nur die Gast-Rolle. Das Konto wird mit allen zugehörigen Daten unwiderruflich gelöscht und kann nicht wiederhergestellt werden.": "„{name}“ hat nur die Gast-Rolle. Das Konto wird mit allen zugehörigen Daten unwiderruflich gelöscht und kann nicht wiederhergestellt werden.",
  "„{name}“ hat weitere Rollen ({roles}). Es wird nur die Gast-Rolle mit den Gast-Daten entfernt; das Konto bleibt bestehen. Alle Sitzungen des Kontos werden beendet.": "„{name}“ hat weitere Rollen ({roles}). Es wird nur die Gast-Rolle mit den Gast-Daten entfernt; das Konto bleibt bestehen. Alle Sitzungen des Kontos werden beendet.",
  "Gastkonto wurde gelöscht.": "Gastkonto wurde gelöscht.",
  "Gast-Rolle wurde entfernt.": "Gast-Rolle wurde entfernt.",
  "Gastkonto wurde nicht gefunden.": "Gastkonto wurde nicht gefunden.",
  "{count} Unterkunfts-Verknüpfungen": {
    "one": "{count} Unterkunfts-Verknüpfung",
    "other": "{count} Unterkunfts-Verknüpfungen"
  },
  "{count} Reisepläne": {
    "one": "{count} Reiseplan",
    "other": "{count} Reisepläne"
  },
  "{count} Chat-Verläufe": {
    "one": "{count} Chat-Verlauf",
    "other": "{count} Chat-Verläufe"
  },
  "{count} Umfrage-Einladungen": {
    "one": "{count} Umfrage-Einladung",
    "other": "{count} Umfrage-Einladungen"
  },
  "Seite nicht gefunden": "Seite nicht gefunden",
  "Diese Seite gibt es nicht": "Diese Seite gibt es nicht",
  "Der Link ist veraltet oder unvollständig.": "Der Link ist veraltet oder unvollständig.",
  "Zur Übersicht": "Zur Übersicht",
  "Konzerte & Musik": "Konzerte & Musik",
  "Party & Nachtleben": "Party & Nachtleben",
  "Feste & Festivals": "Feste & Festivals",
  "Märkte": "Märkte",
  "Shows & Performances": "Shows & Performances",
  "Comedy & Kabarett": "Comedy & Kabarett",
  "Film & Kino": "Film & Kino",
  "Ausstellungen & Kunst": "Ausstellungen & Kunst",
  "Lesungen & Literatur": "Lesungen & Literatur",
  "Vorträge & Bildung": "Vorträge & Bildung",
  "Führungen & Touren": "Führungen & Touren",
  "Sport & Bewegung": "Sport & Bewegung",
  "Kinder & Familie": "Kinder & Familie",
  "Essen & Trinken": "Essen & Trinken",
  "Workshops & Kurse": "Workshops & Kurse",
  "Brauchtum & Tradition": "Brauchtum & Tradition",
  "Eintritt frei": "Eintritt frei",
  "Festpreis": "Festpreis",
  "Ab-Preis": "Ab-Preis",
  "Preisspanne": "Preisspanne",
  "Spendenbasis": "Spendenbasis",
  "Keine Preisangabe": "Keine Preisangabe",
  "Stufenloser Zugang": "Stufenloser Zugang",
  "Assistenzhunde willkommen": "Assistenzhunde willkommen",
  "Behindertenparkplatz": "Behindertenparkplatz",
  "Eigene Veranstaltung": "Eigene Veranstaltung",
  "Regionaler Tipp": "Regionaler Tipp",
  "Importiert": "Importiert",
  "Wanderung": "Wanderung",
  "Spaziergang": "Spaziergang",
  "Radtour": "Radtour",
  "Laufstrecke": "Laufstrecke",
  "Klettertour": "Klettertour",
  "Winterwanderung": "Winterwanderung",
  "Schneeschuhtour": "Schneeschuhtour",
  "Langlaufloipe": "Langlaufloipe",
  "Kanutour": "Kanutour",
  "Reittour": "Reittour",
  "Sonstige Tour": "Sonstige Tour",
  "Strecke": "Strecke"
}
